import loadable from "loadable-components";

const SearchPageRoute = loadable(() =>
  import(/* webpackPreload: true, webpackChunkName: "s" */ "../SearchPage")
);

export default SearchPageRoute;
